import React from 'react'

import { prop } from 'ramda'

import { formattedNumber } from '~/src/Lib/Utils'

const fakeDT = {
  precision: 0,
  format: data => data,
}
export const formatTargets = (min, max, dataType = fakeDT, includeUnit = true) => {
  const { precision, format } = dataType
  const formatted = `Target:\u00a0${
    formattedNumber(min, precision)
  } to ${
    formattedNumber(max, precision)
  }`

  return includeUnit ? format(formatted) : formatted
}

export const formatAlerts = (min, max, dataType = fakeDT) => {
  const { precision, format } = dataType

  return `Alert:\u00a0${format(`\uff1c ${
    formattedNumber(min, precision)
  }, \uff1e ${
    formattedNumber(max, precision)
  }`)}`
}

export const getUnits = prop('units')
/* eslint-disable react/prop-types */
export const getTargets = (props, dataType, includeUnit = true) => {
  const { annotation: { targetMin, targetMax } } = props
  return React.createElement('span', null, formatTargets(targetMin, targetMax, dataType, includeUnit))
}

export const getAlerts = (props, dataType) => {
  const { annotation: { alertMin, alertMax } } = props

  return React.createElement('span', null, formatAlerts(alertMin, alertMax, dataType))
}
/* eslint-enable react/prop-types */

export const getAll = (...args) => {
  const [props, dataType] = args

  return React.createElement('span', null, [
    getTargets(props, dataType, false),
    ', ',
    getAlerts(props, dataType)
  ])
}
